import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewAdditional from '@/views/view-additional';

whenDomReady(() => {
  new ViewAdditional({ el: $('#MainContent') });
});
